
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/ImportantLinks.css";
import { AbstractAPI } from "../api";
import API from "../service/axios_config";

const Notification = () => {
  const navigate = useNavigate();

  const [linkSections, setLinkSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchLinks();
  }, []);

  const fetchLinks = async () => {
    try {
      setLoading(true);
      setError("");

      const data = await AbstractAPI.getAllGazatteLinks();

      console.log("API RESPONSE:", data);

      // Handle DRF pagination OR normal array
      const list = Array.isArray(data) ? data : data.results || [];

      if (!list.length) {
        setLinkSections([]);
        return;
      }

      /* ================= GROUP BY HEADING ================= */
      const grouped = {};

      list
        .filter(item => item.is_active !== false)
        .forEach(item => {
          const heading = item.message || "General";

          if (!grouped[heading]) {
            grouped[heading] = [];
          }

          grouped[heading].push({
            title: item.title || "View",
            url: item.file_path ? `${API.defaults.baseURL}/file/get?filepath=${item.file_path}` : item.gadget_type,
          });
        });

      const sections = Object.keys(grouped).map(heading => ({
        heading,
        links: grouped[heading],
      }));

      setLinkSections(sections);

    } catch (err) {
      console.error("Fetch failed:", err);
      setError("Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */

  if (loading) {
    return <div className="important-links-page">Loading Gazette Notifications...</div>;
  }

  if (error) {
    return <div className="important-links-page">{error}</div>;
  }

  return (
    <div className="important-links-page">
      <div className="important-top-bar">
        <button className="clear-filters-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2 className="important-title">Gazette Notifications</h2>
      </div>

      <div className="important-links-wrapper">

        {linkSections.length === 0 ? (
          <p className="no-links">No Gazette Notifications Available</p>
        ) : (
          linkSections.map((section, index) => (
            <div
              key={index}
              className="important-link-section"
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                overflow: "hidden",
                background: "#fff",
                marginBottom: "16px",
                paddingTop: "0px",
                paddingBottom: "0px",
              }}
            >
              <table
                className="important-links-table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  {section.links.map((link, idx) => (
                    <tr
                      key={idx}
                      style={{
                        borderBottom:
                          idx !== section.links.length - 1
                            ? "1px solid #e5e7eb"
                            : "none",
                      }}
                    >
                      <td
                        className="important-link-title"
                        onClick={() => window.open(link.url, "_blank")}
                        onMouseEnter={(e) => (e.target.style.color = "#2563eb")}
                        onMouseLeave={(e) => (e.target.style.color = "#111827")}
                        style={{
                          padding: "16px",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#111827",
                          cursor: "pointer",
                          transition: "color 0.3s ease",
                        }}
                      >
                        {section.heading}
                      </td>

                      <td
                        className="important-link-action"
                        style={{
                          padding: "16px",
                          textAlign: "right",
                        }}
                      >
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="visit-btn"
                          style={{
                            color: "#2563eb",
                            textDecoration: "none",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          View →
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
        )}

      </div>
    </div >
  );
};

export default Notification;
